import { trackElementClicked } from '@/features/shared/analytics/element'

export const trackElementClickedForAddedAddress = (message?: string) =>
  trackElementClicked({
    type: 'button',
    content: 'entering a new address',
    message_goal: message || 'successful address',
  })
